const STORAGE_KEY = 'crane_game_user_id';

export function getAnonymousUserId(): string {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

export function getOrCreateAnonymousUserId(): string {
  return getAnonymousUserId();
}

export function clearAnonymousUserId(): void {
  localStorage.removeItem(STORAGE_KEY);
}
